(() => {
  const modal = document.getElementById('navira-shipping-modal');
  if (!modal || modal.dataset.initialized) return;
  modal.dataset.initialized = 'true';
  let opener;
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('[data-navira-shipping-open]');
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    opener = trigger;
    if (!modal.open) modal.showModal();
  }, true);
  modal.addEventListener('click', event => {
    event.stopPropagation();
    if (event.target === modal || event.target.closest('[data-navira-shipping-close]')) modal.close();
  });
  modal.addEventListener('keydown', event => {
    if (event.key === 'Escape') event.stopPropagation();
  });
  modal.addEventListener('cancel', event => event.stopPropagation());
  modal.addEventListener('close', () => {
    if (opener?.isConnected) opener.focus({ preventScroll: true });
  });
})();
